import {
	ConfirmationCondition,
	ConfirmationConditionFactoryFromJS,
	IConfirmationCondition
} from './IConfirmationCondition';
import {
	FieldSelectionCondition,
	FieldSelectionConditionFactoryFromJS,
	IFieldSelectionCondition
} from './IFieldSelectionCondition';
import {
	IValueEntryCondition,
	ValueEntryCondition,
	ValueEntryConditionFactoryFromJS
} from './IValueEntryCondition';

export type ICondition = IValueEntryCondition | IFieldSelectionCondition | IConfirmationCondition;
export type Condition = ValueEntryCondition | FieldSelectionCondition | ConfirmationCondition;

export const ConditionFactoryFromJS = (data: ICondition) => {
	switch (data.typeName) {
		case 'ValueEntryCondition':
			return ValueEntryConditionFactoryFromJS(data);
		case 'FieldSelectionCondition':
			return FieldSelectionConditionFactoryFromJS(data);
		case 'ConfirmationCondition':
			return ConfirmationConditionFactoryFromJS(data);
	}
};
